import { render } from "./EditClubPage.vue?vue&type=template&id=4646e8a0&scoped=true"
import script from "./EditClubPage.vue?vue&type=script&lang=js"
export * from "./EditClubPage.vue?vue&type=script&lang=js"

import "./EditClubPage.vue?vue&type=style&index=0&id=4646e8a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4646e8a0"]])

export default __exports__